import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, X, ChevronLeft, ChevronRight } from 'lucide-react';

const WomCollectiveProject = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  const galleryImages = [
    'https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/7yjml8i2_edit_000052720003.jpg',
    'https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/srl9tcbs_0editpainters-12.jpg',
    'https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/2h878znx_000058820012.jpg',
    'https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/pte7aa2l_painters-13.jpg',
    'https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/v6dzi2k7_WOM%20Collective.jpg',
    'https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/putt702z_edit_000052720012.jpg',
    'https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/xscg8dhs_000058820013.jpg',
    'https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/nyg6af4i_edit_000052720014.jpg',
    'https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/j6xwjst2_000052720005.jpg',
  ];

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <div className="bg-cream min-h-screen">
      {/* Back Button */}
      <div className="fixed top-24 left-6 md:left-12 z-40">
        <Link 
          to="/#photography" 
          className="inline-flex items-center gap-2 text-green hover:text-green/70 transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="text-sm uppercase tracking-wider">Back</span>
        </Link>
      </div>

      {/* Title */}
      <section className="pt-32 pb-8 px-6 md:px-12">
        <div className="max-w-5xl mx-auto text-center">
          <h1 
            className="text-6xl md:text-8xl lg:text-9xl uppercase text-green mb-4"
            style={{ fontFamily: 'Anton, sans-serif' }}
          >
            WOM Collective
          </h1>
          <p className="text-xl md:text-2xl text-green/70">
            London's female-led street art scene
          </p>
        </div>
      </section>

      {/* Image Gallery Grid - Uniform squares */}
      <section className="px-6 md:px-12 lg:px-24 pb-24 pt-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {galleryImages.map((image, idx) => (
              <div 
                key={idx} 
                className="aspect-square cursor-pointer overflow-hidden"
                onClick={() => openLightbox(idx)}
              >
                <img 
                  src={image} 
                  alt={`WOM Collective ${idx + 1}`}
                  className="w-full h-full object-cover hover:opacity-90 transition-opacity"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxOpen && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center">
          <button 
            onClick={closeLightbox}
            className="absolute top-6 right-6 text-white hover:text-white/70 transition-colors"
          >
            <X size={32} />
          </button>
          <button 
            onClick={prevImage}
            className="absolute left-6 text-white hover:text-white/70 transition-colors"
          >
            <ChevronLeft size={48} />
          </button>
          <img 
            src={galleryImages[currentImageIndex]} 
            alt={`Gallery ${currentImageIndex + 1}`}
            className="max-h-[90vh] max-w-[90vw] object-contain"
          />
          <button 
            onClick={nextImage}
            className="absolute right-6 text-white hover:text-white/70 transition-colors"
          >
            <ChevronRight size={48} />
          </button>
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/70 text-sm">
            {currentImageIndex + 1} / {galleryImages.length}
          </div>
        </div>
      )}
    </div>
  );
};

export default WomCollectiveProject;
